'use client';

import { PropsWithChildren } from 'react';
import { useCrashOnLocalStorageFlag } from '@/_hooks/use-crash-on-local-storage-flag';
import { HC_FORCE_CRASH } from '@/_constants/common';

export function CrashGate({ children }: PropsWithChildren) {
  useCrashOnLocalStorageFlag({
    key: HC_FORCE_CRASH,
    message: 'TEST ERROR: forced crash by localStorage flag',
  });

  return children;
}
